import { escapeHtml } from '@/utils/escapeHtml';

/**
 * The "Combo" (bet builder) pseudo-group shown in the market group tabs of an
 * event detail. Its icon follows the admin badge config (image, custom text or
 * the default "BB" pill).
 *
 * The returned `svg` is rendered with v-html by SmartToolbar: admin-provided
 * text and URL are escaped, otherwise a badge text like <img onerror=...> runs
 * as script.
 */
export function buildBetBuilderGroupTab(store, locale) {
    const config = store.getters['settings/getBadgeIconConfig']('betBuilder', 24);
    const imageActive = config.imageEnabled === true &&
        typeof config.imageUrl === 'string' && config.imageUrl.trim().length > 0;
    const customTextValue = config.text?.[locale];
    const customText = (!imageActive && config.enabled &&
        typeof customTextValue === 'string' && customTextValue.trim().length > 0)
        ? customTextValue : null;
    // Admin-adjustable width; height stays 14 (fixed tab-row height). Always a
    // positive number: it is interpolated into the markup below.
    const width = Number(config.size) > 0 ? Number(config.size) : 24;
    const svg = imageActive
        ? `<img src="${escapeHtml(config.imageUrl)}" width="${width}" height="14" style="object-fit:contain" alt="" />`
        : `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="14" viewBox="0 0 ${width} 14"><rect width="${width - 4}" height="14" rx="3" fill="var(--color-primary-light, #f90)"/><text x="${width / 2}" y="10" text-anchor="middle" font-family="Arial,sans-serif" font-size="9" font-weight="900" fill="#000">${escapeHtml(customText || 'BB')}</text></svg>`;
    return { _id: 'betbuilder', name: 'Combo', svg };
}
